<template>
  <div id="list">
    <label v-for="option in options" :key="option.id" class="container">
      <svg viewBox="0 0 8 1.4" class="pallete-svg">
        <rect :fill="option.colors[0]" x="1.5" y="0" height="1.8" width="1.8" />
        <rect :fill="option.colors[1]" x="3.8" y="0" height="1.8" width="1.8" />
        <rect :fill="option.colors[2]" x="6.1" y="0" height="1.8" width="1.8" />
      </svg>
      <input
        type="radio"
        :checked="option.checked"
        name="radio"
        :value="option.id"
        @click="clicked(option)"
      />
      <span class="checkmark"></span>
    </label>
  </div>
</template>

<script>
export default {
  name: 'HypoRadioSet',
  props: ['value', 'options'],
  methods: {
    clicked(option) {
      this.$emit('input', option)
    }
  },
  created() {
    this.value = this.options[0]
  }
}
</script>

<style scoped>
/* The container */
.container {
  text-align: left;
  display: block;
  position: relative;
  padding-left: 10%;
  margin-bottom: 1.2em;
  cursor: pointer;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}
.pallete-svg {
  overflow: visible;
}
/* Hide the browser's default radio button */
.container input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
}

/* Create a custom radio button */
.checkmark {
  position: absolute;
  top: 7.5%;
  left: 0;
  height: 80%;
  width: 15%;
  background-color: #e6e6e6;
  border: solid 2px #cacaca;
  border-radius: 50%;
}

/* On mouse-over, add a grey background color */
.container:hover input ~ .checkmark {
  background-color: #ccc;
}

/* When the radio button is checked, add a blue background */
.container input:checked ~ .checkmark {
}

/* Create the indicator (the dot/circle - hidden when not checked) */
.checkmark:after {
  content: '';
  position: absolute;
  display: none;
}

/* Show the indicator (dot/circle) when checked */
.container input:checked ~ .checkmark:after {
  display: block;
}

/* Style the indicator (dot/circle) */
.container .checkmark:after {
  top: 20%;
  left: 20%;
  width: 60%;
  height: 60%;
  border-radius: 50%;
  background: #505050;
}
</style>
